module.exports = __webpack_public_path__ + "static/media/left-triangle.f0369536.svg";